const PortfolioHoldingsTable = require('okCharts/PortfolioHoldingsTable');

module.exports = PortfolioHoldingsTable;
